import { Coin } from '@cakedefi/cake-sdk';

export function getCoinDisplayName(coin: Coin) {
  if (coin.category === 'CRYPTOCURRENCY') {
    return coin.name;
  }
  return coin.id;
}
